import { render, staticRenderFns } from "./webHook.vue?vue&type=template&id=2c639065&scoped=true"
import script from "./webHook.vue?vue&type=script&lang=js"
export * from "./webHook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c639065",
  null
  
)

export default component.exports